/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popGuide.vue?vue&type=template&id=1f5bc8c4"
import script from "./popGuide.vue?vue&type=script&lang=js"
export * from "./popGuide.vue?vue&type=script&lang=js"
import style0 from "./popGuide.vue?vue&type=style&index=0&id=1f5bc8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports